<template>
  <div>
    <canvas
      ref="signatureCanvas"
      :width="width"
      :height="height"
      style="border: 1px solid #ccc; touch-action: none; border-bottom: 3px solid #000;"
    ></canvas>
    <span class="text-danger small" v-if="error">
      {{ error }}
    </span>
    <div style="margin-top: 10px;">
      <button @click="clearCanvas" class="btn btn-warning btn-sm" >Limpar</button>
      <button @click="saveSignature" class="btn btn-success btn-sm ml-2" >Salvar</button>
    </div>
  </div>
</template>
  
<script>
import SignaturePad from 'signature_pad';

export default {
  props: {
    width: {
      type: Number,
      default: 500,
    },
    height: {
      type: Number,
      default: 300,
    },
  },
  data() {
    return {
      signaturePad: null,
      signatureBase64: '', // Propriedade para guardar a assinatura em Base64
      error: null,
    };
  },
  mounted() {
    const canvas = this.$refs.signatureCanvas;
    this.signaturePad = new SignaturePad(canvas);
  },
  methods: {
    clearCanvas() {
      this.signaturePad.clear();
      this.signatureBase64 = ''; // Limpa também a propriedade Base64
      this.error = null;
    },
    saveSignature() {
      if (this.signaturePad.isEmpty()) {
        this.error = 'Assinatura está vazia!';
        return;
      }
      this.signatureBase64 = this.signaturePad.toDataURL(); // Armazena a assinatura em Base64 na propriedade
      console.log('Assinatura salva como Base64:', this.signatureBase64);

      // Aqui você pode emitir um evento para o componente pai, se necessário:
      this.$emit('update:signature', this.signatureBase64);
    },
  },
};
</script>
